// extracted by mini-css-extract-plugin
export var closeButton = "_kz-1";
export var closeX = "_kz-3";
export var container = "_kz-0";
export var image = "_kz-2";